import { Menu, MenuButton } from '@retail/components';
import { Add } from '@mui/icons-material';
import { Button, ListSubheader, MenuItem, Stack, useTheme } from '@mui/material';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { CheckIcon, EyeIcon } from '@shared/custom-icons';
import { MonitoringAssortment } from '@retail/monitoring-assortment/types';
import { useMemo } from 'react';

interface Props {
  availableMonitoringAssortments: MonitoringAssortment[];
  monitoringAssortmentIds: number[];
  updateItemInAssortment: (assortmentId: number) => void;
  onAddToNewMonitoringAssortments: () => void;
}

export const AddToMonitoringAssortmentMenu: React.FC<Props> = ({
  availableMonitoringAssortments,
  monitoringAssortmentIds,
  updateItemInAssortment,
  onAddToNewMonitoringAssortments,
}) => {
  const t = useAssortmentTFunction();
  const theme = useTheme();

  const monitoringAssortmentIdsItemIsIncludedIn = useMemo(
    () =>
      availableMonitoringAssortments
        .filter((assortment) => monitoringAssortmentIds.includes(assortment.id))
        .map(({ id }) => id),
    [monitoringAssortmentIds, availableMonitoringAssortments]
  );

  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton size="small" color="secondary" variant="outlined" startIcon={<EyeIcon />}>
            {t('assortment.monitorItem')}
          </MenuButton>
          <ListSubheader>{t('assortment.addToNewAssortment')}</ListSubheader>

          <MenuItem
            LinkComponent={Button}
            onClick={() => {
              onClose();
              onAddToNewMonitoringAssortments();
            }}
          >
            <Add />
            {t('assortment.newAssortment')}
          </MenuItem>
          <ListSubheader>{t('assortment.addToExistingAssortment')}</ListSubheader>
          {availableMonitoringAssortments.map((assortment) => {
            return (
              <MenuItem
                key={assortment.id}
                LinkComponent={Button}
                onClick={() => {
                  onClose();
                  updateItemInAssortment(assortment.id);
                }}
              >
                <Stack flexDirection="row" alignItems="center" gap={4}>
                  {monitoringAssortmentIdsItemIsIncludedIn.includes(assortment.id) ? (
                    <CheckIcon bgColor={theme.vars.palette.background.paper} />
                  ) : (
                    <Stack width={20} />
                  )}
                  {assortment.title}
                </Stack>
              </MenuItem>
            );
          })}
        </>
      )}
    </Menu>
  );
};
